import { Box, createStyles, Group, Stack, Text } from '@mantine/core';
import React from 'react';

import { useFeatureFlags } from '@portals/api/partners';

import { DesignColorInput } from '../fields/ColorField';
import { DesignImageInput } from '../fields/ImageField';

export const NavigationMenu = () => {
  const { classes } = useStyles();
  const featureFlags = useFeatureFlags();

  return (
    <Stack spacing="md">
      <Text className={classes.sectionTitle}>Logo</Text>

      <DesignImageInput
        valuePath={['design', 'navigation_menu', 'logo']}
        field={{
          name: 'logo',
          cropConfig: {
            aspectRatio: 1,
            width: 84,
            height: 84,
          },
          previewConfig: {
            width: 84,
            height: 84,
          },
          height: 200,
          inputProps: {
            mb: 15,
          },
        }}
      />

      {featureFlags.navigation_menu_design ? (
        <>
          <Group>
            <Text className={classes.sectionTitle}>Color Palette</Text>
          </Group>

          <Box className={classes.colorFields}>
            <DesignColorInput
              label="Menu Background Color"
              valuePath={['design', 'navigation_menu', 'menu_background_color']}
            />

            <DesignColorInput
              label="Company Text Color"
              valuePath={['design', 'navigation_menu', 'company_text_color']}
            />

            <DesignColorInput
              label="Menu Text Color"
              valuePath={['design', 'navigation_menu', 'menu_text_color']}
            />

            <DesignColorInput
              label="Selected Section BG Color"
              valuePath={[
                'design',
                'navigation_menu',
                'selected_section_background_color',
              ]}
            />

            <DesignColorInput
              label=" Selected Section Text Color"
              valuePath={[
                'design',
                'navigation_menu',
                'selected_section_text_color',
              ]}
            />

            <DesignColorInput
              label="Hovered Section BG Color"
              valuePath={[
                'design',
                'navigation_menu',
                'hovered_section_background_color',
              ]}
            />

            <DesignColorInput
              label="Hovered Section Text Color"
              valuePath={[
                'design',
                'navigation_menu',
                'hovered_section_text_color',
              ]}
            />
          </Box>
        </>
      ) : null}
    </Stack>
  );
};

const useStyles = createStyles((theme) => ({
  sectionTitle: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.blue_gray[5],
  },
  colorFields: {
    display: 'grid',
    gridGap: theme.spacing.xl,
  },
}));
